import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'y42-git-branch-name-display',
  templateUrl: './git-branch-name-display.component.html',
  styleUrls: ['./git-branch-name-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitBranchNameDisplayComponent {
  @Input() name = '';
}
